module.exports = {"hideFooterCTA":true,"embedFooter":"domain-availability-checker"}


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/data/domains/global-settings.json
// module id = vw+c
// module chunks = 0